import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { useTheme } from 'styled-components';
const GlowingIconWrapper = styled.div `
  width: 6px;
  height: 6px;
  position: relative;
  overflow: visible;
`;
const GlowingSVG = styled.svg `
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
export const NotificationDotIcon = ({ variant, glowing = true, ref, ...props }) => {
    const { palette } = useTheme();
    const color = variant === 'primary'
        ? '#68C9FF'
        : variant === 'success'
            ? '#04D900'
            : variant === 'warning'
                ? palette.warning[9]
                : palette.error[9];
    return glowing ? (_jsx(GlowingIconWrapper, { children: _jsxs(GlowingSVG, { width: "30", height: "30", viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [_jsx("g", { opacity: "0.5", filter: "url(#filter0_f_2428_3314)", children: _jsx("circle", { cx: "15", cy: "15", r: "5", fill: color }) }), _jsx("circle", { cx: "15", cy: "15", r: "3", fill: color }), _jsx("defs", { children: _jsxs("filter", { id: "filter0_f_2428_3314", x: "0", y: "0", width: "30", height: "30", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB", children: [_jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }), _jsx("feBlend", { mode: "normal", in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }), _jsx("feGaussianBlur", { stdDeviation: "5", result: "effect1_foregroundBlur_2428_3314" })] }) })] }) })) : (_jsx("svg", { width: "6", height: "6", viewBox: "0 0 6 6", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: _jsx("circle", { cx: "3", cy: "3", r: "3", fill: color }) }));
};
NotificationDotIcon.displayName = 'NotificationDotIcon';
//# sourceMappingURL=notification-dot-icon.js.map